import { ActionIcon, Box, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { MessageAttachment } from '../chat/types';

export function ChatFileCard({
  file,
  onRemove,
}: {
  file: MessageAttachment;
  onRemove?: () => void;
}) {
  return (
    <Box
      pos="relative"
      w={150}
      p="sm"
      style={{
        flex: '0 0 auto',
        borderRadius: 12,
        border: '1px solid rgba(255, 255, 255, 0.12)',
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
      }}
    >
      {onRemove && (
        <ActionIcon
          variant="filled"
          color="gray"
          radius="xl"
          size="sm"
          aria-label={`Remove ${file.filename}`}
          onClick={onRemove}
          style={{ position: 'absolute', top: 4, right: 4 }}
        >
          <IconX size={12} />
        </ActionIcon>
      )}
      <Text
        size="sm"
        c="gray.3"
        lineClamp={2}
        mih={40}
        pr={onRemove ? 20 : undefined}
        style={{ wordBreak: 'break-word' }}
      >
        {file.filename}
      </Text>
      <Box
        mt="sm"
        px={8}
        py={2}
        w="fit-content"
        style={{ borderRadius: 6, backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
      >
        <Text size="xs" c="gray.2" fw={FONT_WEIGHTS.medium} tt="uppercase">
          {file.extension}
        </Text>
      </Box>
    </Box>
  );
}
